var card_default = {
  "link": "_2y0S-",
  "container": "laITN",
  "cardLayout": "FeUUF",
  "imageEnd": "lI6IH",
  "imageStart": "UfBqC",
  "imageTop": "Ya-t2",
  "right": "wyYB6",
  "ltr": "L0rtu",
  "rtl": "r5r8e",
  "imageContainer": "ieEXO",
  "image": "TZsOf",
  "responsiveImage": "clryX",
  "squareImage": "kpj1a",
  "rectangleImage": "LGfnp",
  "squareRatio": "UHzOX",
  "rectangleRatio": "ITJDQ",
  "imageFill": "T9uOd",
  "imageFit": "UzvhY",
  "imageRibbon": "rQaJm"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
